import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import client from "../../services/client";
import { ENDPOINTS } from "../../config";

export const fetchSimActionSlice = createAsyncThunk(
  "simAction/fetchAll",
  async (payload, thunkApi) => {
    // debugger;
    try {
      const response = await client.get(ENDPOINTS.getAllAction);

      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

// Define the initial state for your slice
const initialState = {
  simActionList: [],
  status: "idle",
  error: null,
};

const simActionSlice = createSlice({
  name: "simAction",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSimActionSlice.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSimActionSlice.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.simActionList = action.payload?.data;
      })
      .addCase(fetchSimActionSlice.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message;
      });
  },
});

export default simActionSlice.reducer;
